import { createContext } from 'react';

export const DropdownMenuMockContext = createContext<{
  defaultOpen: boolean;
}>({
  defaultOpen: false,
});
